// extracted by mini-css-extract-plugin
export default {"container":"sync_rule_entity_link_container__eiUPA","link":"sync_rule_entity_link_link__MLajT","icon":"sync_rule_entity_link_icon__-I9JL"};